<template>
  <div v-if="value">
    <m-form-row :label="$t(`${translationPrefix}-address-street`)">
      <m-text-field
        data-cy="address-street"
        v-model="address.streetAddress"
        :placeholder="$t(`${translationPrefix}-address-street`)"></m-text-field>
    </m-form-row>

    <m-form-row :label="$t(`${translationPrefix}-address-locality`)">
      <m-text-field
        data-cy="address-locality"
        v-model="address.addressLocality"
        :placeholder="$t(`${translationPrefix}-address-locality`)"></m-text-field>
    </m-form-row>

    <m-form-row :label="$t(`${translationPrefix}-address-postalcode`)">
      <m-postal-code-field data-cy="address-postalcode" v-model="address.postalCode" :country="country" :rules="[]" />
    </m-form-row>

    <m-form-row :label="$t(`${translationPrefix}-address-region`)">
      <m-region-select data-cy="address-region" :country="country" :level="2" v-model="region" />
    </m-form-row>

    <m-form-row :label="$t(`${translationPrefix}-address-country`)">
      <m-select :value="country" :items="countries" item-text="label" item-value="code" :readonly="true" />
    </m-form-row>
  </div>
</template>

<script lang="ts">
import {Country} from '@mapit/common-utils/dist/types'
import Vue, {PropType} from 'vue'

import {findSecondLevelRegionByName, getCountry, PostalAddress} from '@/utils/administrative-region-helper'

export default Vue.extend({
  name: 'AddressFormGroup',
  props: {
    value: Object as PropType<PostalAddress>,
    translationPrefix: String,
    dealerCountry: String as PropType<Country>,
  },
  data() {
    return {
      address: this.value,
      countries: [
        {code: Country.Spain, label: this.$t(`countries.${Country.Spain}`)},
        {code: Country.Portugal, label: this.$t(`countries.${Country.Portugal}`)},
      ],
      region: findSecondLevelRegionByName(this.value.addressRegion, getCountry(this.value, this.dealerCountry)),
      country: getCountry(this.value, this.dealerCountry),
    }
  },
  watch: {
    region: {
      immediate: true,
      handler(val, oldVal) {
        if (val && val !== oldVal) {
          this.address.addressRegion = val.name
        }
      },
    },
  },
})
</script>
